import React, {
    FunctionComponent,
    useCallback,
    useEffect,
    useRef,
    useState
} from "react";
import usePIP from "@/src/hooks/usePIP";

import styles from "@/src/app/[locale]/home/video.module.css";
import {openPIP, supportsPIP} from "@/src/lib/PIP";
import {Constants} from "@/src/lib/constants";
import {CloseCircleOutlined} from "@ant-design/icons";
import {Button, ConfigProvider} from "antd";
import {useRouter} from "@/src/i18n/routing";
import {ThemeService} from "@/src/services/theme";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const VideoComponent: FunctionComponent = () => {

    const [isPIPOn, setIsPIPOn] = useState(true);
    const router: any = useRouter()
    const themeColors = ThemeService.getThemeColors()
    const breakpoint = useBreakpoint()

    return (
        <ConfigProvider
            theme={{
                components: {
                    Button: {
                        defaultBg: themeColors.primary,
                        defaultColor: themeColors.tertiary,
                        defaultHoverBg: themeColors.secondary,
                        defaultHoverColor: themeColors.tertiary,
                        defaultActiveBg: themeColors.secondary,
                        defaultActiveColor: themeColors.tertiary,
                        defaultActiveBorderColor: themeColors.tertiary,
                        defaultHoverBorderColor: themeColors.primary
                    }
                }
            }}
        >
        <div className={isPIPOn ? styles.ContainerAbs : breakpoint.md ? styles.Container : styles.ContainerXs}>
            <div style={{position: "absolute", top:5, right: 5, zIndex: 1000, display: isPIPOn ? "block" : "none"}}>
                <Button
                    type={"default"}
                    size={"small"}
                    shape="circle"
                    icon={<CloseCircleOutlined style={{fontSize: 24, color: "#FFF"}}/>}
                    onClick={()=>{
                        setIsPIPOn(false)
                        router.replace("#video");
                    }}
                />

            </div>
            <video
                muted={true}
                loop={true}
                src={Constants.videoLink}
                autoPlay={true}
                controls
                disablePictureInPicture
                controlsList="nodownload noplaybackrate"
                className={styles.Video}
            />

        </div>
        </ConfigProvider>
    );
};

export default VideoComponent;
